export const getPaymentTypeOrder = (
  jobType: EnumType<typeof ENUMS.JobType> | undefined,
) => {
  switch (jobType) {
    case ENUMS.JobType.GRANT: {
      return [
        ENUMS.JobPaymentType.FIXED_PRICE,
        ENUMS.JobPaymentType.HOURLY,
        ENUMS.JobPaymentType.MONTHLY,
        ENUMS.JobPaymentType.ANNUAL,
        ENUMS.JobPaymentType.PER_TASK,
        ENUMS.JobPaymentType.FIXED_PROJECT,
      ];
    }
    case ENUMS.JobType.FREELANCE: {
      return [
        ENUMS.JobPaymentType.HOURLY,
        ENUMS.JobPaymentType.MONTHLY,
        ENUMS.JobPaymentType.ANNUAL,
        ENUMS.JobPaymentType.PER_TASK,
        ENUMS.JobPaymentType.FIXED_PRICE,
        ENUMS.JobPaymentType.FIXED_PROJECT,
      ];
    }
    case ENUMS.JobType.DIRECT_HIRE: {
      return [
        ENUMS.JobPaymentType.ANNUAL,
        ENUMS.JobPaymentType.HOURLY,
        ENUMS.JobPaymentType.MONTHLY,
        ENUMS.JobPaymentType.PER_TASK,
        ENUMS.JobPaymentType.FIXED_PRICE,
        ENUMS.JobPaymentType.FIXED_PROJECT,
      ];
    }
    case undefined:
    default: {
      return [
        ENUMS.JobPaymentType.FIXED_PRICE,
        ENUMS.JobPaymentType.ANNUAL,
        ENUMS.JobPaymentType.HOURLY,
        ENUMS.JobPaymentType.MONTHLY,
        ENUMS.JobPaymentType.PER_TASK,
        ENUMS.JobPaymentType.FIXED_PROJECT,
      ];
    }
  }
};
